const PhoneNumber = require('awesome-phonenumber');

class Utils {

  static getPoundsAndPennies(amount) {
    if (!amount) return 'N/A';
    return '£' + this.getPounds(amount) + '.' + this.getPennies(amount)
  }

  static getVanImgFromSize(size) {
    if (size === 'Medium') return require(`../assets/vans/medium-realistic.png`);
    if (size === 'Long') return require(`../assets/vans/long-realistic.png`);
    return require(`../assets/vans/luton-realistic.png`)
  }

  static waitForGlobal({ key, sub }, callback) {
    if (window[key]) {
      if (sub) {
        if (window[key][sub]) {
          callback()
        } else {
          setTimeout(function() {
            Utils.waitForGlobal({ key, sub }, callback)
          }, 100)
        }
      } else {
        callback()
      }
    } else {
      setTimeout(function() {
        Utils.waitForGlobal({ key, sub }, callback)
      }, 100)
    }
  }

  static getPounds(amount) {
    if (amount === 0) {
      return '0'
    }
    let str = amount.toString();
    return str.toString().substring(0, str.length - 2)
  }

  static getPennies(amount) {
    if (amount === 0) {
      return '00'
    }
    let str = amount.toString();
    return str.slice(-2);
  }

  static getHoursAndMinutes(minutes) {
    let h = Math.floor(minutes / 60);
    let m = minutes % 60;
    if (h === 0) {
      return m + ' mins'
    } else {
      return h + ' hrs, ' + m + ' mins'
    }
  }

  static generateGuid() {
    const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  }

  static isBlank(str) {
    return (!str || /^\s*$/.test(str));
  }

  static isValidEmail(query) {
    if (!query) {
      return false
    }

    let emailBeforeAtSign = query.substr(0, query.indexOf('@'));

    emailBeforeAtSign = emailBeforeAtSign.split('.').join("");
    const emailAfterAtSign = query.substr(query.indexOf('@'), query.length);

    const email = emailBeforeAtSign + emailAfterAtSign;

    const emailToTest = email.replace(/\s/g, '');

    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(emailToTest).toLowerCase());
  }

  static isValidMobile(str) {
    let isBlank = (!str || /^\s*$/.test(str));
    if (isBlank) return false;
    if (str.length < 5) return false;

    const strFirstThree = str.substring(0, 3);

    // +441892870777 should not be valid - landline

    // +447809090090 is valid
    if (strFirstThree === '+44') {
      if (str.charAt(3) !== '7') return false; // Must start with 07
      const pn = new PhoneNumber(str, 'UK');
      return pn.isValid()
    }

    // 447809090090 is valid
    if (strFirstThree === '447' || strFirstThree === '440') {
      if (str.charAt(2) !== '7') return false; // Must start with 07
      const pn = new PhoneNumber(`+${str}`, 'UK');
      return pn.isValid()
    }

    // 07809090090 is valid
    if (strFirstThree.charAt(0) === '0' && strFirstThree.charAt(1) === '7') {
      const pn = new PhoneNumber(`+44${str}`, 'UK');
      return pn.isValid()
    }

    // Nothing else is valid
    return false;
  }

  static isValidPassword(password) {
    return password.length > 5;
  }

}

export default Utils;



// WEBPACK FOOTER //
// ./src/library/utils.js